import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { BodyFatCalc } from "../components/BodyFatCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.bf_tool_name()}
        toolPath="/body-fat-calculator"
      />
      <SciHeader title={m.bf_h1()} intro={m.bf_intro()} />
      <BodyFatCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.bf_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.bf_ex1(), m.bf_ex2(), m.bf_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.bf_faq_q1(), a: m.bf_faq_a1() },
          { q: m.bf_faq_q2(), a: m.bf_faq_a2() },
          { q: m.bf_faq_q3(), a: m.bf_faq_a3() },
          { q: m.bf_faq_q4(), a: m.bf_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
